import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const ManageCheckItemState = Immutable.fromJS({

  alert: {
    style: null,
    message: null
  },

  modal: {
    show: false,
    category: null,
    ckSet: null,
    request: {
      description: '',
      price: 0.0,
      note: ''
    }
  }

});

const manageCheckItemReducer = handleActions({

  SWITCH_CHECK_ITEM_MODAL_VISIBILITY: (state, { payload }) => {
    let object = state.get('modal');
    object = object.set('show', payload.visibility);
    object = object.set('category', payload.category);
    object = object.set('ckSet', payload.ckSet);
    return state.merge({
      modal: object,
    })
  },

  HIDE_CHECK_ITEM_MODAL: (state, { payload }) => {
    return state.merge({
      modal: state.get('modal').set('show', false),
    })
  },

  SET_CHECK_ITEM_MODAL_DESCRIPTION: (state, { payload }) => {
    let object = state.get('modal');
    let req = object.get('request').set('description', payload);
    object = object.set('request', req)

    return state.merge({
      modal: object,
    })
  },

  SET_CHECK_ITEM_MODAL_PRICE: (state, { payload }) => {
    let object = state.get('modal');
    let req = object.get('request').set('price', payload);
    object = object.set('request', req)

    return state.merge({
      modal: object,
    })
  },

  SET_CHECK_ITEM_MODAL_NOTE: (state, { payload }) => {
    let object = state.get('modal');
    let req = object.get('request').set('note', payload);
    object = object.set('request', req)
    return state.merge({
      modal: object,
    })
  },

}, ManageCheckItemState);

export default manageCheckItemReducer;


// WEBPACK FOOTER //
// ./src/reducers/manageCheckItemReducer.js